import { render } from "./RouterLinkDropDownMenuItem.vue?vue&type=template&id=090756a4"
import script from "./RouterLinkDropDownMenuItem.vue?vue&type=script&lang=js"
export * from "./RouterLinkDropDownMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__